import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HealthReportUpsellContent } from "gql/graphql";

export type UpsellAdDataState = {
  healthReportUpsellContent: null | HealthReportUpsellContent;
};

const initialState: UpsellAdDataState = { healthReportUpsellContent: null };

const upsellAdDataSlice = createSlice({
  name: "upsellAdData",
  initialState,
  reducers: {
    setUpsellAdData(state, action: PayloadAction<UpsellAdDataState>) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setUpsellAdData } = upsellAdDataSlice.actions;
export default upsellAdDataSlice;
